/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, ProjectFieldDTO, ProjectFieldWriteDTO } from '../fastAPI.schemas'

/**
 * The organisation's project data fields, oldest first.
 * @summary Get Organisation Project Fields
 */
export const getOrganisationProjectFields = (signal?: AbortSignal) => {
  return customInstance<ProjectFieldDTO[]>({
    url: `/my-organisation/project-fields`,
    method: 'GET',
    signal,
  })
}

export const getGetOrganisationProjectFieldsQueryKey = () => {
  return [`/my-organisation/project-fields`] as const
}

export const getGetOrganisationProjectFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganisationProjectFields>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOrganisationProjectFields>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrganisationProjectFieldsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationProjectFields>>> = ({
    signal,
  }) => getOrganisationProjectFields(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationProjectFields>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetOrganisationProjectFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganisationProjectFields>>
>
export type GetOrganisationProjectFieldsQueryError = HTTPValidationError

/**
 * @summary Get Organisation Project Fields
 */

export function useGetOrganisationProjectFields<
  TData = Awaited<ReturnType<typeof getOrganisationProjectFields>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOrganisationProjectFields>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganisationProjectFieldsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Add a project data field to every project of the organisation (admins
only). Existing projects fill it in the next time they are edited.
 * @summary Create Organisation Project Field
 */
export const createOrganisationProjectField = (
  projectFieldWriteDTO: ProjectFieldWriteDTO,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectFieldDTO>({
    url: `/my-organisation/project-fields`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: projectFieldWriteDTO,
    signal,
  })
}

export const useCreateOrganisationProjectFieldMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisationProjectField>>,
    TError,
    { data: ProjectFieldWriteDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganisationProjectField>>,
  TError,
  { data: ProjectFieldWriteDTO },
  TContext
> => {
  const mutationKey = ['createOrganisationProjectField']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganisationProjectField>>,
    { data: ProjectFieldWriteDTO }
  > = props => {
    const { data } = props ?? {}

    return createOrganisationProjectField(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/my-organisation/project-fields` },
    {
      operationId: 'create_organisation_project_field_my_organisation_project_fields_post',
      operationName: 'createOrganisationProjectField',
    },
  )

  return customOptions
}

export type CreateOrganisationProjectFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganisationProjectField>>
>
export type CreateOrganisationProjectFieldMutationBody = ProjectFieldWriteDTO
export type CreateOrganisationProjectFieldMutationError = HTTPValidationError

/**
 * @summary Create Organisation Project Field
 */
export const useCreateOrganisationProjectField = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisationProjectField>>,
    TError,
    { data: ProjectFieldWriteDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrganisationProjectField>>,
  TError,
  { data: ProjectFieldWriteDTO },
  TContext
> => {
  const mutationOptions = useCreateOrganisationProjectFieldMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Delete one project data field (admins only).
 * @summary Delete Organisation Project Field
 */
export const deleteOrganisationProjectField = (fieldGuid: string) => {
  return customInstance<unknown>({
    url: `/my-organisation/project-fields/${fieldGuid}`,
    method: 'DELETE',
  })
}

export const useDeleteOrganisationProjectFieldMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganisationProjectField>>,
    TError,
    { fieldGuid: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganisationProjectField>>,
  TError,
  { fieldGuid: string },
  TContext
> => {
  const mutationKey = ['deleteOrganisationProjectField']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganisationProjectField>>,
    { fieldGuid: string }
  > = props => {
    const { fieldGuid } = props ?? {}

    return deleteOrganisationProjectField(fieldGuid)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/my-organisation/project-fields/{fieldGuid}` },
    {
      operationId:
        'delete_organisation_project_field_my_organisation_project_fields__field_guid__delete',
      operationName: 'deleteOrganisationProjectField',
    },
  )

  return customOptions
}

export type DeleteOrganisationProjectFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganisationProjectField>>
>

export type DeleteOrganisationProjectFieldMutationError = HTTPValidationError

/**
 * @summary Delete Organisation Project Field
 */
export const useDeleteOrganisationProjectField = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganisationProjectField>>,
    TError,
    { fieldGuid: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganisationProjectField>>,
  TError,
  { fieldGuid: string },
  TContext
> => {
  const mutationOptions = useDeleteOrganisationProjectFieldMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Replace one project data field (admins only). Its type is fixed; select
options keep their ``id`` so the projects' choices survive.
 * @summary Update Organisation Project Field
 */
export const updateOrganisationProjectField = (
  fieldGuid: string,
  projectFieldWriteDTO: ProjectFieldWriteDTO,
) => {
  return customInstance<ProjectFieldDTO>({
    url: `/my-organisation/project-fields/${fieldGuid}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: projectFieldWriteDTO,
  })
}

export const useUpdateOrganisationProjectFieldMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisationProjectField>>,
    TError,
    { fieldGuid: string; data: ProjectFieldWriteDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganisationProjectField>>,
  TError,
  { fieldGuid: string; data: ProjectFieldWriteDTO },
  TContext
> => {
  const mutationKey = ['updateOrganisationProjectField']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganisationProjectField>>,
    { fieldGuid: string; data: ProjectFieldWriteDTO }
  > = props => {
    const { fieldGuid, data } = props ?? {}

    return updateOrganisationProjectField(fieldGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/my-organisation/project-fields/{fieldGuid}` },
    {
      operationId:
        'update_organisation_project_field_my_organisation_project_fields__field_guid__put',
      operationName: 'updateOrganisationProjectField',
    },
  )

  return customOptions
}

export type UpdateOrganisationProjectFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganisationProjectField>>
>
export type UpdateOrganisationProjectFieldMutationBody = ProjectFieldWriteDTO
export type UpdateOrganisationProjectFieldMutationError = HTTPValidationError

/**
 * @summary Update Organisation Project Field
 */
export const useUpdateOrganisationProjectField = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisationProjectField>>,
    TError,
    { fieldGuid: string; data: ProjectFieldWriteDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganisationProjectField>>,
  TError,
  { fieldGuid: string; data: ProjectFieldWriteDTO },
  TContext
> => {
  const mutationOptions = useUpdateOrganisationProjectFieldMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * The project data fields of this project's organisation, oldest first.
 * @summary Get Project Project Fields
 */
export const getProjectProjectFields = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ProjectFieldDTO[]>({
    url: `/projects/${projectGuid}/project-fields`,
    method: 'GET',
    signal,
  })
}

export const getGetProjectProjectFieldsQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/project-fields`] as const
}

export const getGetProjectProjectFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectProjectFields>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectProjectFields>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProjectProjectFieldsQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectProjectFields>>> = ({
    signal,
  }) => getProjectProjectFields(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectProjectFields>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetProjectProjectFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectProjectFields>>
>
export type GetProjectProjectFieldsQueryError = HTTPValidationError

/**
 * @summary Get Project Project Fields
 */

export function useGetProjectProjectFields<
  TData = Awaited<ReturnType<typeof getProjectProjectFields>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectProjectFields>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectProjectFieldsQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
